import { useEffect, useRef, useState } from "react";
import {ExcelBtn, formBtn1,formBtn2,inputClass,pageClass,pageHeader, TeamLeadExcelBtn} from "../Utils/CustomClasses";
import Table from "../Table/Table";
import { toast } from "react-toastify";
import Error from "../Error/Error";
import { AssignLeadsAPI, GetAllCompanyAPI, GetallLeads2API, StaticUserAPI, } from "../../API/Api";
import { Controller, useForm } from "react-hook-form";
import usePaginatedData from "../Utils/UsePagination";
import { useSelector } from "react-redux";
import { Checkbox } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useThemeColor } from "../Sidebar/SideBarApi";
import { customStyles, onMenuOpen, onMenuClose, downloadCSV, truncateText } from "../Utils/CommonFuntion";
import Select from "react-select";
import DeleteLeadModal from "../Modals/DeleteLeadModal";
import AddLeadd from "../Modals/AddLeadd";
import DeleteMultipleLeads from "../Modals/DeleteMultipleLeads";
import { IconEye } from "@tabler/icons-react";
import { LeadStatusStyles } from "../Utils/StaticData";
import moment from "moment";

export default function Lead2() {
  const { register, control, watch, reset, handleSubmit, formState: { errors }, setValue } = useForm();

  const {
    register: registerForm1,
    handleSubmit: handleSubmitForm1,
    watch: watchForm1,
    setValue: setValueForm1,
    reset: resetForm1,
    control: control1,
    formState: { errors: errorsForm1, isValid: isValidForm1 },
  } = useForm();
  const UserDetails = useSelector((state) => state?.login?.userDetails);
  const companyDetails = useSelector((state) => state?.login?.userDetails?.company);
  const leadStatusOptions = companyDetails?.allowedLeadStatus || [];
  const [Company, setCompany] = useState([]);
  const [Rowdata, setRowdata] = useState([]);
  const [RowId, setRowId] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [RowCheck, setRowCheck] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isApplyDisabled, setIsApplyDisabled] = useState(true);
  const [AssignUsers, setAssignUsers] = useState([]);
  const [AssignUsers2, setAssignUsers2] = useState([]);
  const filterTimeout = useRef();
  const isFirstRender = useRef(true);
  const navigate = useNavigate();
  const themeColor = useThemeColor();
  let companyId = watch("companyId");
  const searchValue = watchForm1("search");
  const leadStatusValue = watchForm1("leadStatus");
  const phoneNumber = watchForm1("phoneNumber");
  const user = watchForm1("user");
  const location = useLocation();


  useEffect(() => {
    setIsApplyDisabled(!(searchValue || leadStatusValue || phoneNumber || user));
  }, [searchValue, leadStatusValue, phoneNumber, user]);

  const assignToOptions =
    AssignUsers != undefined
      ? AssignUsers.map((user) => ({
        value: user?._id,
        label: `${user?.first_name} ${user?.last_name} - ${user?.role?.roleName}`,
      }))
      : [{ value: "", label: "No data found" }];

  const assignToOptions2 =
    AssignUsers2 != undefined
      ? AssignUsers2.map((user) => ({
        value: user?._id,
        label: `${user?.first_name} ${user?.last_name} - ${user?.role?.roleName}`,
      }))
      : [{ value: "", label: "No data found" }];

  const initialFilterState = {
    p: 1,
    company: "",
    search: "",
    leadStatus: "",
    user: "",
    id: UserDetails?._id || "", // Adding user ID
    role: UserDetails?.role?.roleName || "", // Adding role name
  };

  const [filterObject, setFilterObject] = useState({
    ...initialFilterState,
    p: location.state?.restorePage || 1,
  });

  const {
    filterData: LeadsData,
    pageNo,
    records,
    totalRecord,
    pageChangeHandler,
    recordChangeHandler,
    fetchData,
    prevIsValid,
    nextIsValid,
    loader,
} = usePaginatedData(1,50, GetallLeads2API, filterObject);

  const handleNavigate = (row) => {
    navigate("/teamleads-detail", { state: { leadData: row, fromPage: pageNo,from: "Lead2", restoreRecords: records } });
  };

  const onFocus = ({ focused, isDisabled }) => {
    const msg = `You are currently focused on option ${focused.label}${
      isDisabled ? ", disabled" : ""
      }`;
    return msg;
  };

  // Function to select/deselect a single row
  const handleRowSelect = (rowId, checked) => {
    setSelectedRows((prevSelected) => {
      let updatedSelection;
      if (checked) {
        updatedSelection = [...prevSelected, rowId]; // Select the row
      } else {
        updatedSelection = prevSelected.filter((id) => id !== rowId); // Deselect the row
      }

      // Set RowCheck to true only if there are still selected rows
      setRowCheck(updatedSelection.length > 0);
      setRowId(updatedSelection);
      return updatedSelection;
    });
  };

  // "Select All" functionality
  const handleSelectAll = (checked) => {
    if (checked) {
      const allRowIds = LeadsData?.map((row) => row?._id);
      setSelectedRows(allRowIds);
      setRowId(allRowIds);
      setRowCheck(true);
    } else {
      setSelectedRows([]);
      setRowCheck(false);
    }
  };

  const tableColumns = [
    {
      field: "select",
      header: LeadsData?.length > 0 && (
        <Checkbox
          checked={
            selectedRows.length === LeadsData.length &&
            LeadsData.length > 0
          }
          onChange={(e) => handleSelectAll(e.target.checked)}
        />
      ),
      style: true,
      className: "col-select",
      body: (row) => (
        <Controller
          name={`selected_${row.id}`}
          control={control}
          render={() => (
            <Checkbox
              checked={selectedRows.includes(row._id)}
              onChange={(e) => handleRowSelect(row._id, e.target.checked)}
            />
          )}
        />
      ),
    },
    {
      field: "sr_no",
      header: "Sr No",
      style: true,
      body: (row,meta) => {
        return <h6>{(pageNo - 1) * Number(records) + meta.rowIndex + 1}</h6>;
      }
    },
    {
      field: "createdAt",
      header: "Created At",
      style: true,
      body: (row) => (
        <h6>{row?.createdAt ? moment(row.createdAt).format("DD-MM-YYYY") : "-----"}</h6>
      ),
    },
    {
      field: "location",
      header: "Location",
      style: true,
      className: "col-location",
      body: (row) => {
        const fullText = `${row?.city || ""}${row?.city && row?.state ? ", " : ""}${row?.state || ""}`;
        return (
          <>
            <h6 title={fullText}>
              {truncateText(fullText)}
            </h6>
            <h6>{row?.pincode || "----"}</h6>
          </>
        );
      },
    },
    {
      field: "fullName",
      header: "Full Name",
      style: true,
      className: "col-name",
      body: (row) => {
        const fullName = `${row?.firstName || ""} ${row?.lastName || ""}`.trim();
        return (
          <h6 title={fullName || "-----"}>
            {truncateText(fullName, 30)}
          </h6>
        );
      },
    },
    {
      field: "email",
      header: "Email",
      style: true,
      body: (row) => (
        <h6 title={row?.email || "-----"}>
          {truncateText(row?.email || "", 30)}
        </h6>
      ),
    },
    {
      field: "phoneNumber",
      header: "Phone Number",
      style: true,
      className: "col-phone",
      body: (row) => {
        return (
          <>
            <h6>{row?.phoneNumber || "----"}</h6>
          </>
        );
      },
    },
    {
      field: "alternateNumber",
      header: "Alternate Number",
      style: true,
      body: (row) => <h6>{row?.alternateNumber || "------"}</h6>,
    },
    {
      field: "leadSource",
      header: "Lead Source",
      style: true,
      body: (row) => <h6>{row?.leadSource || "-----"}</h6>,
    },
    {
      field: "product",
      header: "Product",
      style: true,
      body: (row) => <h6>{row?.product || "-----"}</h6>,
    },
    {
      field: "assigned_to",
      header: "Assigned To",
      style: true,
      body: (row) => (
        <h6>
          {row?.assigned_to?.first_name && row?.assigned_to?.last_name
            ? `${row.assigned_to.first_name} ${row.assigned_to.last_name}`
            : "----"}
        </h6>
      ),
    },
    {
      field: "company",
      header: "Company",
      style: true,
      body: (row) => <h6>{row?.company?.companyName || "------"}</h6>,
    },
    {
      field: "followUpDetails",
      header: "FDetails",
      style: true,
      body: (row) => {
        const followDate = row?.followDate
        const followTime = row?.followTime;
            const followDateDetails = (followDate) ?  moment(followDate).format("DD-MM-YYYY") : "-----";
        const followTimeDetails = (followTime) ? `${followTime}` : "-----";
            return(
          <>
            <h6>{followDateDetails}</h6>
            <h6>{followTimeDetails}</h6>
          </>
        );
      },
    },
    {
      field: "leadStatus",
      header: "Lead Status",
      style: true,
      className: "col-status",
      body: (row) => <LeadStatusStyles leadStatus={row?.leadStatus} />,
    },
    {
      field: "remark",
      header: "Remark",
      style: true,
      body: (row) => <h6 className='break-words whitespace-pre-line min-w-[20rem]'>{row?.remark || "-----"}</h6>,
    },
    {
      field: "actions",
      header: "Actions",
      style: true,
      className: "col-actions",
      body: (row) => (
        <div className="flex items-center w-full gap-x-2">
          <button
            onClick={(e) => {
              e.preventDefault();
              handleNavigate(row);
            }}
            className="py-1 rounded-lg flex justify-center"
          >
            <IconEye
              size={24}
              className="text-black"
              color="#000"
              stroke={1.5}
            />
          </button>
          <AddLeadd
            edit={true}
            rowdata={row}
            Company={Company}
            iniAssignUsers={AssignUsers}
            filterRecords={filterRecords} />

          {(UserDetails?.role?.roleName == "SuperAdmin" ||
            UserDetails?.role?.roleName == "Admin") && (
              <>
                <DeleteLeadModal row={row} filterRecords={filterRecords} />
              </>
            )}
        </div>
      ),
    },
  ];

  const allowedFields = companyDetails?.allowedLeadTableFields || [];

  let filteredColumns = tableColumns;

  if (allowedFields.length > 0) {
    filteredColumns = tableColumns.filter((col) => {
      return (
        col.field === "select" ||
        col.field === "sr_no" ||
        col.field === "createdAt" ||
        col.field === "actions" ||
        allowedFields.includes(col.field)
      );
    });
  }

  const filterRecords = () => {
    if (filterTimeout.current) {
      clearTimeout(filterTimeout.current);
    }
    filterTimeout.current = setTimeout(async () => {
      await fetchData({ ...filterObject });
      filterTimeout.current = null;
    }, 1500);

    return () => {
      if (filterTimeout.current) {
        clearTimeout(filterTimeout.current);
      }
    };
  };

  const submitPdfExcel = async () => {
    const handleExcelDownload = async () => {
      try {
        const payload = {
          ...filterObject,
          records: 0,
        };
        const response = await GetallLeads2API(payload);
        const LeadsDataAll = response?.data?.filteredData;

        const Header = [
          "firstName",
          "lastName",
          "email",
          "phoneNumber",
          "leadSource",
          "city",
          "state",
          "product",
          "assigned_to",
          "leadStatus",
          "remark",
          "pincode",
          "followDate",
          "followTime",
          "createdAt",
        ];

        const formattedLeadsData = LeadsDataAll.map((lead) => ({
          ...lead,
          assigned_to: `${lead?.assigned_to?.first_name || ""} ${lead?.assigned_to?.last_name || ""}`.trim(),
          company: lead?.company?.companyName || "",
        }));

        downloadCSV(Header, formattedLeadsData, "Leads");
      } catch (err) {
        console.log("Error:", err);
        toast.error("Failed to download Excel");
      }
    };

    handleExcelDownload();
  };

  const getallCompany = async () => {
    try {
      const parentCompanyId = UserDetails?.role?.roleName === "SuperAdmin" ? UserDetails?.company?._id : "";
      const res = await GetAllCompanyAPI(parentCompanyId);
      setCompany(res?.data?.filteredData);
    } catch (err) {
      console.log("Error:", err);
    }
  };
  const handleCompanySelect = async (id) => {
    const companyId = UserDetails?.role?.roleName !== "SuperAdmin" ? UserDetails?.company?._id : id;
    setValue("assign_user", null);
    setAssignUsers([])
    try {
      let response2 = await StaticUserAPI({
        id: UserDetails?._id,
        role: UserDetails?.role?.roleName,
        company: companyId,
      });
      setAssignUsers(response2?.data?.filteredData);
    } catch (err) {
      console.log("Error", err);
    }
  };

  const handleCompanySelect2 = async (id) => {
    const companyId = UserDetails?.role?.roleName !== "SuperAdmin" ? UserDetails?.company?._id : id;
    try {
      let response2 = await StaticUserAPI({
        id: UserDetails?._id,
        role: UserDetails?.role?.roleName,
        company: companyId,
      });
      setAssignUsers2(response2?.data?.filteredData);
    } catch (err) {
      console.log("Error", err);
    }
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    filterRecords();
  }, [filterObject]);

  useEffect(() => {
    getallCompany(UserDetails?.company?._id);
    handleCompanySelect(UserDetails?.company?._id);
    handleCompanySelect2(UserDetails?.company?._id);
  }, []);

  const resetSelection = () => {
    reset({ assign_user: null, companyid: null });
    setRowCheck(false);
    setRowId([]);
    setSelectedRows([]);
  };

  const HandleAssignUsers = async (data) => {
    const payload = {
      leadId: RowId,
      userId: data?.assign_user?.value,
      leadStatus: "Assigned",
      remark: data?.remark,
    };
    try {
      let response = await AssignLeadsAPI(payload);
      if (response?.status == 200) {
        toast.success(response?.data?.message);
        filterRecords();
        resetSelection()
      } else {
        toast.error(response?.response?.data?.error);
        filterRecords();
        resetSelection();
      }
    } catch (err) {
      console.log("Error:", err);
    }
  };

  const filterSubmit = async (data) => {
    const payload = {
      ...filterObject,
      company: data?.companyId ? data?.companyId : "",
      search: data?.search ? data?.search : "",
      phoneNumber: data?.phoneNumber ? data?.phoneNumber : "",
      leadStatus: data?.leadStatus ? data?.leadStatus : "",
      user: data?.user?.value ? data?.user?.value : ""
    };
    setFilterObject(payload);
  };

  return (
    <>
      <div className={`${pageClass} team-leads-page`}>
        <div className="bg-[#FFFFFF] p-10 rounded-xl">
          <div className="flex items-center justify-between">
            <h1 className={`${pageHeader} mb-0`}>Team's Leads</h1>
            <button
              className={TeamLeadExcelBtn}
              onClick={() => submitPdfExcel()}
            >
              Excel
            </button>
          </div>
          <div className="bg-white rounded-xl mt-4">
            <form
              onSubmit={handleSubmitForm1(filterSubmit)}
              className="flex flex-col lg:flex-row gap-3"
            >
              {/* FILTERS */}
              <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
                {UserDetails?.role?.roleName == "SuperAdmin" && (
                  <div>
                    <select
                      name="companyId"
                      className={`${inputClass} !bg-slate-100 ${
                        companyId == "" ? "text-slate-400" : ""
                        }`}
                      {...registerForm1("companyId")}
                      onChange={(e) => handleCompanySelect2(e.target.value)}
                    >
                      <option value="">Company Name</option>

                      {Company?.map((company) => (
                        <option key={company?._id} value={company?._id}>
                          {company?.companyName}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                <div>
                  <input
                    type="text"
                    placeholder="Enter Leads Name / State"
                    className={inputClass}
                    {...registerForm1("search")}
                  />
                </div>

                <div>
                  <select
                    name="Status"
                    className={`${inputClass} !bg-slate-100`}
                    {...registerForm1("leadStatus")}
                  >
                    <option value="">Leads Status</option>

                    {leadStatusOptions.map((status, index) => (
                      <option key={index} value={status}>
                        {status}
                      </option>
                    ))}

                  </select>
                </div>

                <div>
                  <Controller
                    name="user"
                    control={control1}
                    render={({ field }) => (
                      <Select
                        {...field}
                        styles={customStyles}
                        aria-labelledby="aria-label"
                        ariaLiveMessages={{ onFocus }}
                        inputId="aria-example-input"
                        onMenuOpen={onMenuOpen(setIsMenuOpen)}
                        onMenuClose={onMenuClose(setIsMenuOpen)}
                        options={assignToOptions2}
                        placeholder="Select User"
                        maxMenuHeight={220}
                      />
                    )}
                  />
                </div>

                <div>
                  <input
                    type="text"
                    placeholder="Mobile Number"
                    className={inputClass}
                    {...registerForm1("phoneNumber")}
                  />
                </div>
              </div>

              {/* BUTTONS */}
              <div className="flex gap-2 justify-end flex-shrink-0 items-center">
                <button
                  type="submit"
                  className={`${formBtn1} ${
                    isApplyDisabled
                      ? "opacity-50 cursor-not-allowed"
                      : "bg-base-color"
                    }`}
                  disabled={isApplyDisabled}
                >
                  Apply
                </button>

                <button
                  type="button"
                  onClick={() => {
                    resetForm1({
                      user: null,
                      companyId: null,
                      search: null,
                      leadStatus: null,
                      phoneNumber: null,
                    });
                    setFilterObject(initialFilterState);
                  }}
                  className={`${formBtn2} ${
                    isApplyDisabled
                      ? "opacity-50 cursor-not-allowed"
                      : ""
                    }`}
                  disabled={isApplyDisabled}
                >
                  Clear
                </button>
              </div>
            </form>
          </div>
          {RowCheck && (
            <div className="bg-white rounded-xl">
              <form
                onSubmit={handleSubmit(HandleAssignUsers)}
                className="flex md:items-center flex-col lg:flex-row  gap-2 pt-4"
              >
                <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-y-3 gap-x-2">
                  {UserDetails?.role?.roleName == "SuperAdmin" && (
                    <div>
                      <select
                        name="companyid"
                        placeholder="Company Name"
                        className={`${inputClass} !bg-slate-100`}
                        {...register("companyid")}
                        onChange={(e) => handleCompanySelect(e.target.value)}
                      >
                        <option value="">Select Company Name</option>
                        {Company?.map((data) => (
                          <option
                            className="text-black"
                            key={data?._id}
                            value={data?._id}
                          >
                            {data?.companyName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  <div className="">
                    <div className="form-group">
                      <Controller
                        name="assign_user"
                        control={control}
                        rules={{ required: "User is required" }}
                        render={({ field }) => (
                          <>
                            <Select
                              value={field.value || null}
                              styles={customStyles}
                              options={assignToOptions}
                              placeholder="Select User"
                              maxMenuHeight={220}
                              menuPlacement="auto"
                              {...field}
                            />
                            {errors.assign_user && (
                              <Error title={errors.assign_user.message} />
                            )}
                          </>
                        )}
                      />
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <div>
                      <button
                        type="submit"
                        className={`${formBtn1} w-full text-center`}
                      >
                        Assign
                      </button>
                    </div>
                    <div>
                      <DeleteMultipleLeads RowId={RowId} count={RowId.length} filterRecords={filterRecords} resetSelection={resetSelection}/>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          )}
          <div className="mt-4">
            <Table
              key={selectedRows.length}
              columns={filteredColumns}
              data={LeadsData}
              paginatorCheck={true}
              prevIsValid={prevIsValid}
              nextIsValid={nextIsValid}
              pageNo={pageNo}
              pageChangeHandler={pageChangeHandler}
              recordChangeHandler={recordChangeHandler}
              register={register}
              records={records}
              totalRecord={totalRecord}
              loading={loader}
            />
          </div>
        </div>
      </div>
    </>
  );
}
